export const EXTERNAL_LINKS = {
  MI_GUROS: "https://mi.guros.com",
} as const;
